// We don't use MaterialUI, react-intl or any other imports to reduce the chances of failing
import './styles.css';
import styled from 'styled-components';

import { Shirt } from 'atoms/icons/shirts/Shirt';

const RedShirt = styled(Shirt)`
  color: var(--c-red-400);
`;

const BlueShirt = styled(Shirt)`
  color: var(--c-blue-400);
`;

const YellowShirt = styled(Shirt)`
  color: var(--c-yellow-400);
`;

export enum ErrorLevel {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

const levelOfErrorCode = (code: number | string) => {
  if (Number(code) >= 500) return ErrorLevel.ERROR;
  if (Number(code) >= 400) return ErrorLevel.WARNING;
  return ErrorLevel.INFO;
};

const images = {
  error: <RedShirt size={8} />,
  warning: <YellowShirt size={8} />,
  info: <BlueShirt size={8} />,
};

interface ErrorProps {
  message: string;
  code: number | string;
}

const buildClass = (type: string): string => `HandledError-${type}`;

export const HandledError = ({ code, message }: ErrorProps) => {
  const level = levelOfErrorCode(code);

  const handleNavigate = () => window.history.go(-1);

  return (
    <div className={buildClass('root')}>
      <meta httpEquiv="refresh" content="60" />
      <div className={buildClass('container')}>
        <div className={buildClass('image-container')}>
          <div
            className={`${buildClass('error-container-text')} ${buildClass(
              level
            )}`}
          />
          {images[level]}
        </div>
        <div className={`${buildClass('block')} ${buildClass('blockPadded')}`}>
          <h3>{message}</h3>
          <button
            onClick={handleNavigate}
            type="button"
            className={buildClass('button')}
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
};
